import { useSelector } from "react-redux";

import {
  DeploymentPermission,
  SaleyardPermission,
} from "constants/permissions";

import { hasPermission } from "lib/permissions";

import { getIsLivestockAgent } from "selectors";

import { useGetParentObjectFromActiveRole } from "./useGetParentObjectFromActiveRole";

export const useHasCreateRuleBookPermission = () => {
  const isLivestockAgent = useSelector(getIsLivestockAgent);
  const parentObject = useGetParentObjectFromActiveRole();

  const createPermission = isLivestockAgent
    ? DeploymentPermission.canAddRuleBook
    : SaleyardPermission.canAddRuleBook;

  return hasPermission(parentObject, createPermission);
};

export const useHasCreateRulePermission = () => {
  const isLivestockAgent = useSelector(getIsLivestockAgent);
  const parentObject = useGetParentObjectFromActiveRole();

  const createPermission = isLivestockAgent
    ? DeploymentPermission.canAddRule
    : SaleyardPermission.canAddRule;

  return hasPermission(parentObject, createPermission);
};
